import {PlatformLocation} from '@angular/common';
import {Injectable} from '@angular/core';

import {UtilsService} from '@libs/utils/src';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from '@libs/providers/app-config.service';
import {catchError, map, shareReplay} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(
        private platformLocation: PlatformLocation,
        private httpClient: HttpClient,
        private appConfig: AppConfigService
    ) {
    }

    /** Get the user permissions */
    getUserDetails() {
        return this.httpClient.get(this.appConfig.getConfig().APP_LAUNCHER_AUTH + '/userDetails/Fleet_SystemConsole', {withCredentials: true})
            .pipe(
                map((response: any) => {
                    return {
                        isAdmin: (response.permissions && response.permissions.includes('sys:int:adm')),
                        subject: response.subject
                    };
                }),
                catchError(error => {
                    return throwError('Error getting user permissions: ' + JSON.stringify(error));
                })
            );
    }


    logOut() {
        window.location.assign(
            UtilsService.normalizeResourceUri(
                this.platformLocation.getBaseHrefFromDOM() + '/assets/logout.html'
            )
        );
    }
}
